<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import { Card, CardHeader, CardTitle, CardContent } from '@/Components/ui/card'
</script>

<template>
  <AppLayout>
    <div class="container mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <Card>
        <CardHeader>
          <CardTitle>Welcome Home</CardTitle>
        </CardHeader>
        <CardContent>
          <p>This is the Home page.</p>
        </CardContent>
      </Card>
    </div>
  </AppLayout>
</template>
